import { render } from "./FileDownload.vue?vue&type=template&id=44660bd3&scoped=true"
import script from "./FileDownload.vue?vue&type=script&lang=js"
export * from "./FileDownload.vue?vue&type=script&lang=js"

import "./FileDownload.vue?vue&type=style&index=0&id=44660bd3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44660bd3"]])

export default __exports__